var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.referrals)?_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.showReferralsModal()}}},[_vm._v(_vm._s(_vm.referrals))]):_c('span',[_vm._v(_vm._s(_vm.referrals))])])}
var staticRenderFns = []

export { render, staticRenderFns }